import React from 'react';

export default function Row({ children }) {
    return (
        <div className="grid border-b-2 pb-2" style={{ gridTemplateColumns: '1fr auto' }}>
            {children}
        </div>
    );
}
